<template>
  <a-tag :color="color">
    {{ displayText || '' }}
    <slot v-if="!type && !id && !text"></slot>
  </a-tag>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'Tags',
  props: {
    type: {
      type: String,
      required: false
    },
    id: {
      type: [String, Number],
      required: false
    },
    text: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const colorMap = {
      ticketGroup: {
        1: { color: 'processing' }, // CREADO
        2: { color: 'warning' }, // EN CORREDORA
        3: { color: 'warning' }, // EN ASEGURADORA
        4: { color: 'success' }, // EJECUTADO
        5: { color: 'error' }, // CANCELADO
        6: { color: 'error' } // FALLIDO
      },
      stock: {
        1: { color: 'success' }, // ALTA CON KIT
        2: { color: 'processing' }, // ALTA SIN KIT
        3: { color: 'warning' } // BAJA
      }
    };

    const color = computed(() => {
      if (!props.type || props.id === undefined || props.id === null) {
        return 'processing';
      }

      const typeEntry = colorMap[props.type];
      if (!typeEntry) {
        console.warn(`Tipo no válido: ${props.type}`);
        return 'default';
      }

      const entry = typeEntry[props.id];
      if (!entry) {
        console.warn(`ID no válido (${props.id}) para el tipo ${props.type}`);
        return 'default';
      }

      return entry.color || 'default';
    });

    const displayText = computed(() => {
      if (props.type === 'ticketGroup' && !props.text) {
        return 'CREADO';
      }
      return props.text ? props.text.toUpperCase() : '';
    });

    return {
      color,
      displayText
    };
  }
};
</script>
